import { Control, useController } from 'react-hook-form';

import { RemoveExclusionFormValues } from './types';
import {
  createMaxLengthValidator,
  createRequiredValidator,
  isValidInput,
} from '@/utils/validator';

export const useControllers = (
  control: Control<RemoveExclusionFormValues, any, RemoveExclusionFormValues>
) => {
  const {
    field: {
      value: explanation,
      onChange: setExplanation,
      onBlur: validateExplanation,
    },
    fieldState: { error: explanationError },
  } = useController({
    control,
    name: 'explanation',
    rules: {
      validate: {
        isRequired: createRequiredValidator('Required'),
        isValidInput,
        withValidMaxLength: createMaxLengthValidator(2048),
      },
    },
  });

  return {
    explanation,
    setExplanation,
    validateExplanation,
    explanationError,
  };
};
